export enum SearchStatus {
  None = 0, // initial state
  Started = 1, // search in progress
  Success = 2, // search complete (possibly without results or with partial errors)
  Failed = 4 // search failed
}
